/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, userId, auditableType, from, to }) {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (userId) params.append('user_id', userId);
    if (auditableType) params.append('auditable_type', auditableType);
    if (from) params.append('from', from);
    if (to) params.append('to', to);

    const queryString = params.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }
}

export default new AuditLogs();
